import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { Audience, AudienceAgeRange } from "@/lib/types/audience";
import { audienceFromAgeRange } from "@/lib/types/audience";

interface AudienceState {
  audience: Audience | null;
  ageRange: AudienceAgeRange | null;
  lastUpdatedAt: number | null;
  setAudience: (
    audience: Audience,
    ageRange?: AudienceAgeRange | null
  ) => void;
  setFromAgeRange: (ageRange: AudienceAgeRange) => void;
  clearAudience: () => void;
}

function logAudienceSelection(audience: Audience) {
  if (typeof window === "undefined") {
    return;
  }
  console.info("[audience] selection", {
    audience,
    timestamp: new Date().toISOString(),
  });
}

export const useAudienceStore = create<AudienceState>()(
  persist(
    (set) => ({
      audience: null,
      ageRange: null,
      lastUpdatedAt: null,
      setAudience: (audience, ageRange) =>
        set((state) => {
          logAudienceSelection(audience);
          return {
            audience,
            ageRange:
              ageRange !== undefined ? ageRange : state.ageRange,
            lastUpdatedAt: Date.now(),
          };
        }),
      setFromAgeRange: (ageRange) => {
        const audience = audienceFromAgeRange(ageRange);
        set(() => {
          logAudienceSelection(audience);
          return {
            audience,
            ageRange,
            lastUpdatedAt: Date.now(),
          };
        });
      },
      clearAudience: () =>
        set(() => ({
          audience: null,
          ageRange: null,
          lastUpdatedAt: Date.now(),
        })),
    }),
    {
      name: "hamd-audience",
      partialize: (state) => ({
        audience: state.audience,
        ageRange: state.ageRange,
        lastUpdatedAt: state.lastUpdatedAt,
      }),
    }
  )
);
